import { render, staticRenderFns } from "./bindDetailCollapse.vue?vue&type=template&id=47c1709a&scoped=true&"
import script from "./bindDetailCollapse.vue?vue&type=script&lang=js&"
export * from "./bindDetailCollapse.vue?vue&type=script&lang=js&"
import style0 from "./bindDetailCollapse.vue?vue&type=style&index=0&id=47c1709a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1709a",
  null
  
)

export default component.exports